import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Label from 'components/foundations/Label';
import Select from 'components/widgets/Select';
import TagInput from 'components/widgets/TagInput';
import css from '../ExportLogs.css';

const selectStyles = {
    control: base => ({ ...base, minHeight: 35, height: 35, minWidth: 116 }),
    valueContainer: base => ({ ...base, height: 35, paddingTop: 0, paddingBottom: 0 }),
    singleValue: base => ({ ...base, whiteSpace: 'nowrap' }),
};

const optionValueType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

const operationShape = PropTypes.shape({
    name: PropTypes.string.isRequired,
    display_name: PropTypes.string.isRequired,
});

const tagOptionShape = PropTypes.shape({
    label: PropTypes.node,
    value: optionValueType,
    name: PropTypes.string,
    display_name: PropTypes.string,
    id: optionValueType,
    apsalar_id: optionValueType,
    country_code: PropTypes.string,
    agency_id: optionValueType,
    site_id: optionValueType,
});

function FilterTagsRow({
    id,
    labelKey,
    helpKey,
    operation,
    operations,
    onOperationChange,
    suggestions,
    tags,
    placeholder,
    disabled = false,
    onChange,
}) {
    return (
        <div className={css.formRow}>
            <div className={classNames(css.formLabel, css.filterLabel)}>
                <Label text={labelKey} className={css.formLabelText} />
                {helpKey && <span>{helpKey}</span>}
            </div>
            <div className={css.filterControl}>
                <div className={css.operationSelect}>
                    <Select
                        value={operation}
                        options={operations}
                        onChange={onOperationChange}
                        getOptionLabel={option => option.display_name}
                        getOptionValue={option => option.name}
                        isDisabled={disabled}
                        styles={selectStyles}
                    />
                </div>
                <TagInput
                    ariaLabel={id}
                    suggestions={suggestions}
                    tags={tags}
                    disabled={disabled}
                    placeholder={placeholder}
                    onChange={onChange}
                    className={css.tagInput}
                    virtualScrolling
                />
            </div>
        </div>
    );
}

FilterTagsRow.propTypes = {
    id: PropTypes.string.isRequired,
    labelKey: PropTypes.string.isRequired,
    helpKey: PropTypes.node,
    operation: operationShape.isRequired,
    operations: PropTypes.arrayOf(operationShape).isRequired,
    onOperationChange: PropTypes.func.isRequired,
    suggestions: PropTypes.arrayOf(tagOptionShape).isRequired,
    tags: PropTypes.arrayOf(tagOptionShape).isRequired,
    placeholder: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
};

export default FilterTagsRow;
